var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1113.727 327.455v-3.637h-10.909v10.91h3.637v-6.364a.91.91 0 01.909-.91h6.363zm-5.454 1.818v6.363a.91.91 0 01-.91.91h-5.454a.91.91 0 01-.909-.91V322.91a.91.91 0 01.91-.909h12.726a.91.91 0 01.91.91v5.454a.91.91 0 01-.91.909h-6.363zm0 0v10.909h10.909v-10.91h-10.91zm-.91-1.818h12.728a.91.91 0 01.909.909v12.727a.91.91 0 01-.91.909h-12.726a.91.91 0 01-.91-.91v-12.726a.91.91 0 01.91-.91z",
    id: "switch_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#switch_svg__a",
    transform: "translate(-1101 -322)"
  })));
}
export default SvgSwitch;